(function () {
    function initAccordion($) {
        $('.faq-item accordion-custom').each(function () {
            var $accordion = $(this);
            var $details   = $accordion.find('details');
            var $summary   = $details.find('summary');
            var $content   = $details.find('.faq-answer-wrapper');
            var $faqItem   = $accordion.closest('.faq-item');

            $summary.on('click', function (e) {
                e.preventDefault();

                var isOpen = $details.attr('open');

                if (isOpen) {
                    // Close this item
                    $faqItem.removeClass('is-active');
                    $content.stop(true, true).slideUp(300, function () {
                        $details.removeAttr('open');
                    });
                } else {
                    // Close any other open item in the same list
                    $accordion.closest('.faq-items').find('.faq-item.is-active').each(function () {
                        var $other        = $(this);
                        var $otherDetails = $other.find('details');
                        var $otherContent = $other.find('.faq-answer-wrapper');

                        $other.removeClass('is-active');
                        $otherContent.stop(true, true).slideUp(300, function () {
                            $otherDetails.removeAttr('open');
                        });
                    });

                    // Open this item
                    $faqItem.addClass('is-active');
                    $details.attr('open', true);
                    $content.stop(true, true).hide().slideDown(300);
                }
            });
        });
    }

    function waitForJQuery() {
        if (window.jQuery) {
            jQuery(document).ready(function ($) {
                initAccordion($);
            });
        } else {
            setTimeout(waitForJQuery, 50);
        }
    }

    waitForJQuery();
})();
